
import React from 'react'
import './WhatToDo.css'

const WhatToDo = () => {
  return (
    <div>

    <div className="title-info" style={{color: "#0176FF",marginTop: "15vh"}}>
        What if we could do something to <br/>help this process much more stable <br/>and accurate?
        </div>
        <br/>
        <br/> <br/>
        <br/> <br/>
        <br/>
        <div className="title-content" style={{	color: "#42597A"}}>
            <div> Safety issues in synthetic biology experiments are very important because off-target effects in experiments  </div>
            <div>with gene editing can be very dangerous and may lead to uncontrollable outcomes, such as the creation of  </div>
            <div>new superbugs. If we can find the right tools to reduce the harm caused by off-target effects in the future, it</div>
             <div>will be possible to protect the safety of life around the world.</div>
        
        </div>
    
    </div>
  )
}

export default WhatToDo